import { Field, NumericInput, TextOutput } from '../../../../Core';
import { ListFieldSection } from '../../../../Layout';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { WorksheetEquipmentDropdown } from '../../../Core';
import { WorksheetBalanceFieldSet } from '../../../Core/WorksheetEquipment';

const CombustionSectionBase = (): JSX.Element => (
  <ListFieldSection heading="Ash Content &amp; Organic Material">
    <WorksheetBalanceFieldSet label="Balance" name="Combustion.Balance" />
    <Field input={<WorksheetEquipmentDropdown />} label="Furnace" name="Combustion.Furnace" equipmentType="furnace" />
    <Field input={<NumericInput />} label="Furnace Temperature" name="Combustion.FurnaceTemperature" />
    <Field input={<NumericInput />} label="Furnace Duration" name="Combustion.FurnaceDuration" />
    <Field input={<NumericInput />} label="Tare and Ash Mass" name="Combustion.TareAndAshMass" />
    <Field input={<TextOutput />} label="Ash Mass" name="Combustion.AshMass" />
  </ListFieldSection>
);

const CombustionSection = withInjectedProps(CombustionSectionBase);
export { CombustionSection };
export default CombustionSection;
